import { render } from "./Speed150.vue?vue&type=template&id=5157191e"
import script from "./Speed150.vue?vue&type=script&lang=js"
export * from "./Speed150.vue?vue&type=script&lang=js"
script.render = render

export default script